<template>
  <FormulateForm v-model="form" :errors="formErrors" :schema="schema" @changeProperty="change" @submit="submitForm" />
</template>
<script>
import Vue from 'vue';
import PropertyList from '@/web/appraisal/components/PropertyList';

Vue.component('PropertyList', PropertyList);

export default {
  props: {
    selectedProperty: {
      type: Object,
    },
    address: {
      type: String,
      required: true,
    },
    properties: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      form: {},
      property: this.selectedProperty ?? null,
      formErrors: null,
      errors: [],
    };
  },
  computed: {
    addressField() {
      return {
        name: 'address',
        type: 'text',
        disabled: true,
        value: this.address,
      };
    },
    propertiesField() {
      return {
        component: 'PropertyList',
        selectedProperty: this.selectedProperty,
        properties: this.properties,
        '@change': 'changeProperty',
      };
    },
    errortext() {
      return {
        component: 'p',
        class: !!this.formErrors ? 'formulate-input-errors' : 'formulate-input-errors hidden',
        children: this.formErrors,
      };
    },
    backButton() {
      return {
        component: 'a',
        class: 'btn btn-ghost btn-lg',
        children: 'Volver',
        '@click': this.closePopup,
      };
    },
    submitButton() {
      return {
        type: 'submit',
        name: 'submit',
        label: 'Continuar',
      };
    },
    buttons() {
      return {
        component: 'div',
        class: 'btn-container popup__sticky-buttons',
        children: [this.backButton, this.submitButton],
      };
    },
    schema() {
      return [this.addressField, this.propertiesField, this.errortext, this.buttons];
    },
  },
  methods: {
    submitForm() {
      this.formErrors = null;
      if (!this.property) {
        this.formErrors = 'Debes seleccionar una vivienda antes de continuar.';
      } else {
        this.$emit('nextStep', this.property);
      }
    },
    change(property) {
      this.property = property;
    },
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>
